"use client";
import { createContext, useContext, useState, ReactNode } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { z } from "zod";
import { formSchema } from "../components/home/components/TripAuditInspection";

type FormData = z.infer<typeof formSchema>;

type TripAuditContextType = {
  methods: ReturnType<typeof useForm<FormData>>;
  showInsurannceCover: boolean;
  setShowInsurannceCover: (value: boolean) => void;
  showInvoicePreCheckout: boolean; // ← NEW
  setShowInvoicePreCheckout: (value: boolean) => void; // ← NEW
  showInvoiceForm: boolean;
  setShowInvoiceForm: (value: boolean) => void;
  currentStep: number;
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
};

const TripAuditContext = createContext<TripAuditContextType | null>(null);
const today = new Date();
// cons t
// clone date for end date
const next7Days = new Date();
next7Days.setDate(today.getDate() + 7);
const formatDate = (date: Date) =>
  date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

export const TripAuditProvider = ({ children }: { children: ReactNode }) => {
  const methods = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      vehicle: {
        make: "",
        model: "",
        year: "",
        fuelType: "Gasoline",
        color: "",
        vin: "",
      },
      owner: { fullName: "", email: "", phone: "", address: "" },
      driver: {
        sameAsOwner: false,
        fullName: "",
        email: "",
        phone: "",
        license: "",
        address: "",
      },
      inspection: {
        plan: "Single",
        access_limit_time: "30",
        license_verification: false,
      },
      trip: { startDate: formatDate(today), endDate: formatDate(next7Days) },
    },
  });

  const [showInsurannceCover, setShowInsurannceCover] = useState(false);
  const [showInvoicePreCheckout, setShowInvoicePreCheckout] = useState(false); // ← NEW
  const [showInvoiceForm, setShowInvoiceForm] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  return (
    <TripAuditContext.Provider
      value={{
        methods,
        showInsurannceCover,
        setShowInsurannceCover,
        showInvoiceForm,
        setShowInvoiceForm,
        showInvoicePreCheckout, // ← NEW
        setShowInvoicePreCheckout,
        currentStep,
        setCurrentStep,
      }}
    >
      <FormProvider {...methods}>{children}</FormProvider>
    </TripAuditContext.Provider>
  );
};

export const useTripAudit = () => {
  const context = useContext(TripAuditContext);
  if (!context)
    throw new Error("useTripAudit must be used within TripAuditProvider");
  return context;
};
